import { LanguageCode, LANGUAGES_NAMES } from '../constants/languages';

export const getLanguageName = (languageCode: string | LanguageCode) => {
  return (
    LANGUAGES_NAMES.find((language) => languageCode.includes(language.value))?.name || 'English'
  );
};
